import React from 'react';
import { Form, Input } from 'antd';
import { Button } from '../../components/Button';
import { EyeIcon } from '../../icons/EyeIcon';
import { EyeInvisibleIcon } from '../../icons/EyeInvisibleIcon';
import { ArrowIcon } from '../../icons/ArrowIcon';


const LoginForm = ({ onLogin }) => {
    return(
        <Form
            name="login_form"
            layout="vertical"
            className="login-form"
            requiredMark={false}
            onFinish={onLogin}
        >
            <Form.Item
                label="Email"
                name="username"
                rules={[{ required: true, message: 'Please input your email!' }]}
            >
                <Input 
                    bordered={false}
                    className="sp-input sp-paragraph"
                />
            </Form.Item>
            <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
            >
                <Input.Password 
                    bordered={false}
                    className="sp-input sp-paragraph"
                    iconRender={(visible) => visible ? <span><EyeIcon /></span> : <span><EyeInvisibleIcon /></span>}
                />
            </Form.Item>
            <Form.Item>
                <Button type="primary">
                    Sign In
                    <ArrowIcon />
                </Button>
            </Form.Item>
        </Form>
    );
};

export { LoginForm };